import { ref, nextTick } from 'vue';

/** Full-screen route transition (Vue; may paint one frame late) */
export const globalPageLoading = ref(true);

let pendingNavigations = 0;

const BLOCKER_ID = 'jamrock-route-sync-blocker';

function setSyncRouteBlocker(visible) {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(BLOCKER_ID);
  if (!el) return;
  el.classList.toggle('is-visible', visible);
}

function isPanelPath(path) {
  return typeof path === 'string' && path.startsWith('/configuracion');
}

function isPanelInternalNavigation(from, to) {
  return isPanelPath(from?.path) && isPanelPath(to?.path);
}

export function markRouteLoadingStart(from, to) {
  pendingNavigations += 1;

  /* Dentro del panel no hay navbar pública: evitar overlay negro entre secciones */
  if (isPanelInternalNavigation(from, to)) {
    return;
  }

  globalPageLoading.value = true;
  /* Síncrono: no espera al tick de Vue (evita 1 frame con navbar blanca) */
  setSyncRouteBlocker(true);
}

export function markRouteLoadingEnd() {
  pendingNavigations -= 1;
  if (pendingNavigations < 0) {
    pendingNavigations = 0;
  }
}

export function isRouteLoadingIdle() {
  return pendingNavigations === 0;
}

/** Quitar overlay cuando el router terminó y el DOM actualizó */
export function scheduleGlobalLoadingOff() {
  nextTick(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (isRouteLoadingIdle()) {
          globalPageLoading.value = false;
          setSyncRouteBlocker(false);
        }
      });
    });
  });
}

export function resetRouteLoading() {
  pendingNavigations = 0;
  globalPageLoading.value = false;
  setSyncRouteBlocker(false);
}
